import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8cb732e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-config-page" }
const _hoisted_2 = { class: "ws_common_operation" }
const _hoisted_3 = { class: "table ws_common_table" }

import { onMounted, ref } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { useRoute } from 'vue-router'
import { CODE_ENUM, PAGE_SIZES } from '@/common'
import { ElMessage } from 'element-plus'
import OperationButtonList from '@/components/operation-button-list'
import { msgbox } from '@/utils'
import ReportConfigForm from './components/report-onfig-form.vue'
import {
  queryReportConfigPage,
  startReportConfig,
  stopReportConfig,
  deleteReportConfig,
} from '@/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const advancedRef = ref()

const toChangeStatus = async ({ enableStatus, id }: any) => {
  const fn = enableStatus ? stopReportConfig : startReportConfig
  const res: any = await fn({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

const toDelete = (row: any) => {
  msgbox({
    tip: '您确定要删除这个配置吗?',
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteReportConfig({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

const getButtonList = ({ enableStatus }: any) => {
  return [
    {
      text: enableStatus ? '关闭' : '开启',
      onClick: toChangeStatus,
    },
    {
      text: '编辑',
      onClick: handleForm,
    },
    {
      text: '删除',
      onClick: toDelete,
    },
  ]
}

const formInline: any = ref({
  reportName: undefined,
})

onMounted(async () => {
  fetchList()
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)
const columns: any = [
  {
    label: '报表名称',
    prop: 'reportName',
  },
  {
    label: '数据类型',
    prop: 'dataType',
  },
  {
    label: '执行方式',
    prop: 'executeDesc',
  },
]

const tableData = ref([])
const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryReportConfigPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    total.value = res?.data?.total || 0
    tableData.value = res?.data?.records || []
  }
}

const formtConf = ref({
  visible: false,
  data: {},
})

const handleForm = (data = {}) => {
  formtConf.value = {
    visible: true,
    data,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        class: "advanced-wrapper",
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        border: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "报表名称",
            prop: "reportName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.reportName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.reportName) = $event)),
                class: "ws_select",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: handleForm,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("新建运营报表")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {"width":"100%"}
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
              return _createVNode(_component_el_table_column, _mergeProps({
                key: item.prop
              }, {
            ...item,
          }, { "show-overflow-tooltip": "" }), null, 16)
            }), 64)),
            _createVNode(_component_el_table_column, {
              label: "启用状态",
              width: "160"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: scope.row.enableStatus ? 'success' : 'info'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.enableStatus ? '启用' : '关闭'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "300"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  buttonList: getButtonList(scope.row),
                  scope: scope.row
                }, null, 8, ["buttonList", "scope"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _createVNode(ReportConfigForm, {
      visible: formtConf.value.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((formtConf.value.visible) = $event)),
      data: formtConf.value.data,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})